import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const richTextDefinition: ComponentDefinition = {
  id: 'richTextExperience',
  name: 'Rich text',
  category: 'Basic',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/text.svg',
  variables: {
    content: {
      displayName: 'Content',
      type: 'RichText',
      validations: {
        bindingSourceType: ['manual', 'entry'],
      },
    },
    size: {
      displayName: 'Text size',
      type: 'Text',
      defaultValue: 'typo-body-md',
      group: 'style',
      validations: {
        in: [
          { value: 'typo-body-md', displayName: 'Size: Medium | Weight: Normal' },
          { value: 'typo-body-md-medium', displayName: 'Size: Medium | Weight: Bold' },
          { value: 'typo-body-sm', displayName: 'Size: Small | Weight: Normal' },
          { value: 'typo-body-sm-medium', displayName: 'Size: Small | Weight: Bold' },
        ],
      },
    },
    colorHeading: {
      displayName: 'Heading colour',
      type: 'Text',
      defaultValue: 'body-text-grey',
      group: 'style',
      validations: {
        in: [
          { value: 'headings-grey', displayName: 'Grey' },
          { value: 'headings-dark-purple', displayName: 'Purple' },
          { value: 'headings-white', displayName: 'White' },
          { value: 'headings-white-on-dark', displayName: 'White on dark' },
          { value: 'headings-pink-accent', displayName: 'Pink' },
          { value: 'headings-link-blue', displayName: 'Link blue' },
        ],
      },
    },
    colorText: {
      displayName: 'Body text colour',
      type: 'Text',
      defaultValue: 'body-text-grey',
      group: 'style',
      validations: {
        in: [
          { value: 'text-text-grey', displayName: 'Grey' },
          { value: 'text-text-dark-purple', displayName: 'Purple' },
          { value: 'text-text-white', displayName: 'White' },
          { value: 'text-text-white-on-dark', displayName: 'White on dark' },
          { value: 'text-text-pink-accent', displayName: 'Pink' },
          { value: 'text-text-link-blue', displayName: 'Link blue' },
        ],
      },
    },
    colorLink: {
      displayName: 'Link colour',
      type: 'Text',
      defaultValue: 'link-link-blue',
      group: 'style',
      validations: {
        in: [
          { value: 'link-link-blue', displayName: 'Link blue' },
          { value: 'link-dark-purple', displayName: 'Purple' },
          { value: 'link-grey', displayName: 'Grey' },
          { value: 'link-pink-accent', displayName: 'Pink' },
          { value: 'link-white', displayName: 'White' },
          { value: 'link-white-on-dark', displayName: 'White on dark' },
        ],
      },
    },
    textAlign: {
      displayName: 'Text align',
      type: 'Text',
      defaultValue: 'text-center',
      group: 'style',
      validations: {
        in: [
          { value: 'text-left', displayName: 'Left' },
          { value: 'text-center', displayName: 'Center' },
          { value: 'text-right', displayName: 'Right' },
        ],
      },
    },
    listIcon: {
      displayName: 'List (ul) icon',
      type: 'Text',
      defaultValue: 'default',
      group: 'style',
      validations: {
        in: [
          { value: 'default', displayName: 'Default' },
          { value: 'check', displayName: 'Check' },
        ],
      },
    },
  },
} as const;
